export const stores = [
  {
    name: 'Rockets concept store (ул. Валовая, 35Б, м. Добрынинская)',
    location: {
      latitude: 55.729037,
      longitude: 37.626547,
    },
    workTime: `Ежедневно 09:00-23:00`,
  },
  {
    name: 'Cappuccino Kids, «Москино Салют» (ул. Кедрова, 14к3, м. Академическая)',
    location: {
      latitude: 55.682818,
      longitude: 37.571309,
    },
    workTime: `Пн-Вс 10:00-22:00`,
  },
  // {
  //   name: 'Кофейня Cappuccino Kids, «РТИ» (ул. Электрозаводская, 27с9, м. Электрозаводская)',
  //   location: {
  //     latitude: 55.791349,
  //     longitude: 37.707036,
  //   },
  //   workTime: `Пн-Пт 08:30-18:00\r\nСб-Вс - Выходной`,
  // },
  {
    name: 'rockets.coffee shop (ул. Авиаконструктора Миля, 3А, м. Жулебино)',
    location: {
      latitude: 55.686787,
      longitude: 37.851943,
    },
    workTime: `Пн-Чт 09:00-22:00\r\nПт-Сб 09:00-23:00\r\nВс 09:00-22:00`,
  },
  {
    name: 'Rockets concept store (Тверской бул., 3)',
    location: {
      latitude: 55.758357,
      longitude: 37.598052,
    },
    workTime: `Ежедневно 09:00-23:00`,
  },
  // {
  //   name: 'Кофейня Cappuccino Kids, «БЦ Новосущевский» (ул. Сущевский вал, 18, м. Марьина Роща)',
  //   location: {
  //     latitude: 55.791977,
  //     longitude: 37.603244,
  //   },
  //   workTime: `Пн-Пт 08:30-18:30`,
  // },
  {
    name: 'Rockets concept store (ул. Садовническая, 82с2)',
    location: {
      latitude: 55.735616,
      longitude: 37.642384,
    },
    workTime: `Ежедневно 09:00-23:00`,
  },
]

export const loyaltyStages = [
  { name: "Stage 0", discount: "3", threshold: 0 },
  { name: "Stage 1", discount: "5", threshold: "5 000" },
  { name: "Stage 2", discount: "10", threshold: "10 000" },
  { name: "Stage 3", discount: "15", threshold: "15 000" },
  { name: "Stage Pro", discount: "20", threshold: "40 000" },
]

export const coffeeShops = [
  {
    name: 'rockets.concept store',
    location: {
      latitude: 55.758357,
      longitude: 37.598052,
    },
    description: [
      'Тверской бул., 3',
      'Ежедневно 9:00-23:00',
    ],
    tags: [ 'rockets_concept_store', 'coffee_with_food' ],
    image: '/images/coffee-shops/store-1.jpg',
  },
  {
    name: 'rockets.concept store',
    location: {
      latitude: 55.729037,
      longitude: 37.626547,
    },
    description: [
      'БЦ Wall Street, ул. Валовая 35Б',
      'Ежедневно 9:00-23:00',
    ],
    tags: [ 'rockets_concept_store', 'coffee_with_food' ],
    image: '/images/coffee-shops/store-2.webp',
  },
  {
    name: 'rockets.concept store',
    location: {
      latitude: 55.735616,
      longitude: 37.642384,
    },
    description: [
      'ул. Садовническая, 82с2',
      'Ежедневно 09:00-23:00',
    ],
    tags: [ 'rockets_concept_store', 'coffee_with_food' ],
    image: '/images/coffee-shops/sadovnicheskaya.webp',
  },
  {
    name: 'rockets.coffee shop',
    location: {
      latitude: 55.686791,
      longitude: 37.851990,
    },
    description: [
      'Фудмолл «Привоз»',
      'Пн-Чт 09:00–22:00',
      'Пт-Сб 09:00–23:00',
      'Вс 09:00–22:00',
    ],
    tags: [ 'rockets_coffee_shop' ],
    image: '/images/coffee-shops/shop.webp',
  },
  {
    name: 'Cappuccino Kids Port Plaza',
    location: {
      latitude: 55.692967,
      longitude: 37.659730,
    },
    description: [
      'БЦ Port Plaza, Проектируемый проезд №4062, дом 6, строение 2',
      'Пн-Пт 8:30-18:00',
      'Сб-Вс — Выходной',
      'При себе необходимо иметь паспорт или в/у для оформления пропуска на ресепшене',
    ],
    tags: [ 'coffee_with_food', 'cappuccino_kids' ],
    image: '/images/coffee-shops/portplaza.webp',
  },
  {
    name: 'Cappuccino Kids «Отрадное»',
    location: {
      latitude: 55.857159,
      longitude: 37.599795,
    },
    description: [
      'БЦ Технопарк «Отрадное», ул. Отрадная, 2Бс1',
      'Пн-Пт 8:00-18:00',
      'Сб-Вс — Выходной',
      'При себе необходимо иметь паспорт или в/у для оформления пропуска. Для оформления пропуска напишите нам на почту shop@rockets.coffee',
    ],
    tags: [ 'coffee_with_food', 'cappuccino_kids' ],
    image: '/images/coffee-shops/otradnoe.webp',
  },
  {
    name: 'Cappuccino Kids strEAT',
    location: {
      latitude: 55.710129,
      longitude: 37.654610,
    },
    description: [
      'Гастрономическая улица strEAT, ул. Ленинская слобода, 26',
      'Пн-Чт 10:00–22:00',
      'Пт 10:00–23:00',
      'Сб 11:00–23:00',
      'Вс 11:00–22:00',
    ],
    tags: [ 'cappuccino_kids' ],
    image: '/images/coffee-shops/streat.jpg',
  },
  {
    name: 'Cappuccino Kids «Мамонтов»',
    location: {
      latitude: 55.733705,
      longitude: 37.589482,
    },
    description: [
      'БЦ  «Мамонтов», ул. Тимура Фрунзе, 11к2',
      'Пн-Пт 8:30-18:00',
      'Сб-Вс — Выходной',
    ],
    tags: [ 'cappuccino_kids' ],
    image: '/images/coffee-shops/mamontov.jpg',
  },
  {
    name: 'Cappuccino Kids «Салют»',
    location: {
      latitude: 55.682818,
      longitude: 37.571309,
    },
    description: [
      'Кинотеатр «Салют» / Москино, ул. Кедрова, 14к3',
      'Пн-Вс 10:00-22:00',
    ],
    tags: [ 'cappuccino_kids' ],
    image: '/images/coffee-shops/salut.webp',
  },
  // {
  //   name: 'Cappuccino Kids «РТИ»',
  //   location: {
  //     latitude: 55.791349,
  //     longitude: 37.707036,
  //   },
  //   description: [
  //     'БЦ «РТИ», ул. Электрозаводская, 27к9',
  //     'Пн-Пт 8:30-18:00',
  //     'Сб-Вс — Выходной',
  //   ],
  //   tags: [ 'cappuccino_kids' ],
  //   image: '/images/coffee-shops/rti.jpg',
  // },
  // {
  //   name: 'Cappuccino Kids «БЦ Новосущевский»',
  //   location: {
  //     latitude: 55.791977,
  //     longitude: 37.603244,
  //   },
  //   description: [
  //     '«БЦ Новосущевский», ул. Сущевский вал, 18',
  //     'Пн-Пт 8:30-18:30',
  //   ],
  //   tags: [ 'cappuccino_kids' ],
  //   image: '/images/coffee-shops/suschevsky.jpg',
  // },
]

export const contactsMapPoints = [
  {
    key: 1,
    latitude: 55.729366,
    longitude: 37.626241,
  },
  {
    key: 2,
    latitude: 42.970074,
    longitude: 47.505888,
  },
  {
    key: 3,
    latitude: 44.555352,
    longitude: 38.062061,
  },
]

export const team = [
  {
    name: 'Егор Невейкин',
    position: 'Основатель',
    image: '/images/team/img-1.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Александр Леонов',
    position: 'Коммерческий директор',
    image: '/images/team/img-29.webp',
    favoriteCoffee: '#',
  },
  // {
  //   name: 'Юлия Новичкова',
  //   position: 'Финансовый директор',
  //   image: '/images/team/img-3.webp',
  //   favoriteCoffee: '#',
  // },
  {
    name: 'Игорь Малышев',
    position: 'Операционный директор',
    image: '/images/team/img-4.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Маргарита Князькова',
    position: 'Директор по маркетингу',
    image: '/images/team/img-5.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Александра Малышева',
    position: 'Руководитель отдела продаж',
    image: '/images/team/img-6.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Евгения Баграмян',
    position: 'Менеджер отдела продаж',
    image: '/images/team/img-7.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Юлия Шарпилова',
    position: 'Менеджер отдела продаж',
    image: '/images/team/img-8.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Елена Верхотурова',
    position: 'Менеджер отдела продаж',
    image: '/images/team/img-9.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Анастасия Николаева',
    position: 'Менеджер отдела продаж',
    image: '/images/team/img-10.jpg',
    favoriteCoffee: '#',
  },
  // {
  //   name: 'Дмитрий Мочалов',
  //   position: 'Менеджер отдела продаж',
  //   image: '/images/team/img-27.webp',
  //   favoriteCoffee: '#',
  // },
  {
    name: 'Семён Мотин',
    position: 'Менеджер отдела продаж',
    image: '/images/team/img-28.webp',
    favoriteCoffee: '#',
  },
  {
    name: 'Николай Черкасов',
    position: 'Руководитель rockets.school',
    image: '/images/team/img-11.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Максим Карнаухов',
    position: 'Тренер',
    image: '/images/team/img-12.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Анна Зеркаль',
    position: 'Бухгалтер',
    image: '/images/team/img-13.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Рамиль Мамедов',
    position: 'Менеджер цифровых продуктов',
    image: '/images/team/img-14.webp',
    favoriteCoffee: '#',
  },
  {
    name: 'Ангелина Булыго',
    position: 'SMM',
    image: '/images/team/img-15.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Павел Хрущев',
    position: 'Тренер',
    image: '/images/team/img-16.jpg',
    favoriteCoffee: '#',
  },
  // {
  //   name: 'Александр Аннануров',
  //   position: 'Тренер',
  //   image: '/images/team/img-17.jpg',
  //   favoriteCoffee: '#',
  // },
  {
    name: 'Виктория Очкурова',
    position: 'Специалист по контролю качества',
    image: '/images/team/img-18.jpg',
    favoriteCoffee: '#',
  },
  // {
  //   name: 'Михаил Чернаков',
  //   position: 'Обжарщик',
  //   image: '/images/team/img-19.jpg',
  //   favoriteCoffee: '#',
  // },
  {
    name: 'Николай Телегин-Музалёв',
    position: 'Управляющий производством',
    image: '/images/team/img-20.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Максим Маслов',
    position: 'Менеджер склада',
    image: '/images/team/img-21.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Тимур Дзарданов',
    position: 'Фасовщик зеленого зерна',
    image: '/images/team/img-22.jpg',
    favoriteCoffee: '#',
  },
  // {
  //   name: 'Александр Проданов',
  //   position: 'Старший фасовщик',
  //   image: '/images/team/img-23.jpg',
  //   favoriteCoffee: '#',
  // },
  {
    name: 'Илья Севальнев',
    position: 'Фасовщик',
    image: '/images/team/img-24.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Алексей Смирнов',
    position: 'Руководитель инженерного отдела',
    image: '/images/team/img-25.jpg',
    favoriteCoffee: '#',
  },
  {
    name: 'Алексей Рехтин',
    position: 'Инженер',
    image: '/images/team/img-26.jpg',
    favoriteCoffee: '#',
  },
]

export const dictionary = [
  {
    "term": "Байпас",
    "description": "Добавление воды в концентрированный напиток для снижения насыщенности (англ. bypass)",
  },
  {
    "term": "Батч брю",
    "description": "Кофе, приготовленный в капельной кофемашине (англ. batch brew)",
  },
  {
    "term": "Блуминг",
    "description": "Блуминг (англ. blooming) или предсмачивание – быстрый выход углекислого газа, происходящий при столкновении горячей воды с молотым кофе",
  },
  {
    "term": "Брю рэтио",
    "description": "Брю рэтио (англ. brew ratio) – соотношение молотого кофе к воде, используемой для заваривания",
  },
  {
    "term": "Брю чарт",
    "description": "Брю чарт (англ. brew chart) – контрольная диаграмма заваривания. На вертикальной оси отмечают TDS (концентрация напитка), на горизонтальной экстракцию (количество растворенных веществ)",
  },
  {
    "term": "Влагомер",
    "description": "Прибор для измерения влажности зелёного кофе",
  },
  {
    "term": "Влажность зерна",
    "description": "Один из важных показателей качества зелёного кофе. При любом способе обработки, зёрна перед экспортом высушивают до необходимых показателей влажности — 10-12%. С таким уровнем влажности зерно не стареет и не теряет свои вкусо-ароматические особенности. При более низких показателях эмбрион в зерне начинает умирать, кофе стареет и во вкусе можно наблюдать ноты дерева, бумаги, снижается качество кислотности и тела, вкус становится проще",
  },
  {
    "term": "Воронка V60",
    "description": "Девайс для альтернативного метода заваривания, название V60 происходит от V-образной формы воронки, угол которой равен 60 градусам",
  },
  {
    "term": "Водная активность",
    "description": "Соотношение двух состояний воды внутри зерна — свободной воды, находящейся в межклеточном пространстве и связанной воды, которая привязана к неводным компонентам внутри зерна",
  },
  {
    "term": "Грейд кофе",
    "description": "Способ оценки качества зеленого зерна перед экспортом. Для кофе не существует универсальной системы сортировки и классификации – разные страны-производители имеют свои собственные системы",
  },
  {
    "term": "Грейн про",
    "description": "Грейн про (англ. grain pro) – упаковка для экспорта кофе. Джутовый мешок снаружи, внутри герметичный полиэтиленовый пакет с молнией. В таком мешке кофе не контактирует с окружающей средой, дольше сохраняет влагу и не подвергается грибку или плесени",
  },
  {
    "term": "Грин грейдинг",
    "description": "Грин грейдинг (англ. green grading) – визуальная оценка образца зелёного кофе. Включает в себя контроль цвета зелёного кофе, запаха зелёного зерна, дефектных зёрен и посторонних включений на объем не менее 350 грамм",
  },
  {
    "term": "Гузнэк",
    "description": "Гузнэк (англ. gooseneck) – чайник с тонким носиком для заваривания кофе",
  },
  {
    "term": "Дегазация кофе",
    "description": "Процесс, который происходит во время хранения свежеобжаренного кофе. Во время обжарки кофе образуется большое количество газа (в основном углекислого), который остается в зёрнах и постепенно высвобождается.",
  },
  {
    "term": "Депульпация",
    "description": "Один из этапов обработки, в процессе которого происходит отделение зерна от кожицы и частично от мякоти ягоды.",
  },
  {
    "term": "Депульпатор",
    "description": "Электрический прибор для проведения депульпации кофейной ягоды. Ягоды загружают в депульпатор, в котором вращается зубчатый барабан. Затем они проходят через узкую щель между корпусом депульпатора и барабаном, который и снимает мякоть с ягод. На выходе получаются зёрна в клейковине и остатках мякоти.",
  },
  {
    "term": "Дефекты зелёного кофе",
    "description": "Дефекты в зелёном зерне, возникшие из-за вредителей, нарушений на этапе обработки, хранении или выращивании. Дефекты зелёного зерна разделены на две группы — первичные и вторичные. Первичные оказывают сильное влияние на чашку. Вторичные в небольших количествах безвредны для вкуса, так как зерно не полностью повреждено. В образце спешелти кофе на 350 грамм отсутствуют первичные дефекты и допускаются не более пяти полных вторичных.",
  },
  {
    "term": "Дефекты обжаренного кофе",
    "description": "Дефекты в обжаренном кофе, возникшие из-за ошибок обжарщика (запечёный, недожаренный, тёмный)",
  },
  {
    "term": "Распределитель",
    "description": "Распределитель (англ. distributor)  – инструмент для распределения смолотого кофе в корзине холдера",
  },
  {
    "term": "Драй милл",
    "description": "Драй милл (англ. dry mill) – место подготовки зерна к эспорту. На драй-милле проводят халлинг, кофе очищают от камней, сортируют по размеру и плотности, оценивают на предмет дефектов, вкус и влажность",
  },
  {
    "term": "Иммерсионная воронка",
    "description": "Иммерсионная воронка – Это альтернативный метод заваривания кофе, в котором используется иммерсия (настаивание). На дне такой воронки есть закрывающийся клапан, который останавливает пролив на нужное время.",
  },
  {
    "term": "Инфьюз",
    "description": "Инфьюз (англ. infuse) – искусственное изменение ароматики кофе путём внедрения в кофе во время ферментации сока и мякоти фруктов, специй, алкоголя",
  },
  {
    "term": "Капельная кофемашина",
    "description": "Аппарат для приготовления фильтр-кофе",
  },
  {
    "term": "Каппинг",
    "description": "Процедура оценки кофе",
  },
  {
    "term": "Капсульная кофемашина",
    "description": "Кофемашина для приготовления кофе в капсулах",
  },
  {
    "term": "КАСКАРА",
    "description": "Это засушенная мякоть кофе-ягод. Попробовав напиток из каскары, вы не почувствуйте ожидаемого вкуса, ее запах скорее напоминает чай с фруктами, компот, а профиль обладает довольно обширным спектром ягодно-фруктовых нот.\r\nПо содержанию аминокислот и антиоксидантов она опережает клубнику, малину и чернику, а еще богата такими ценными элементами, как калий и витамин С!\r\n‍\r\nЧтобы приготовить каскару, её заваривают горячей или холодной водой, подслащивая или добавляя содовую с лимоном. На нашем сайте вы найдёте Panama Cascara.",
  },
  {
    "term": "Квакер",
    "description": "Зёрна незрелых ягод. В обжаренном виде имеют светло-желтый, белый цвет",
  },
  {
    "term": "Колесо вкуса",
    "description": "Инструмент для описания вкуса и аромата кофе",
  },
  {
    "term": "Колориметр",
    "description": "Прибор для измерения цвета обжаренного кофе внутри (смолотого) и снаружи",
  },
  {
    "term": "Колорсортер",
    "description": "Оборудование для чистки от посторонних включений и сортировки кофе",
  },
  {
    "term": "Коммерческий кофе",
    "description": "Кофе, который не набрал 80 баллов по шкале SCA",
  },
  {
    "term": "Конвекция",
    "description": "Перенос тепла при помощи нагретого воздуха, к ней относятся такие конвекционные ростеры как fluid bed ростеры, IKAWA сэмпл ростер, IMF ростеры",
  },
  {
    "term": "Кондукция",
    "description": "Перенос тепла в сплошном веществе, другими словами, оно представляет собой контактное обжаривание, к кондукции относятся такие барабанные ростеры, как, например, Giesen или Probat",
  },
  {
    "term": "Конические жернова",
    "description": "\"Разламывают\" зёрна, в большей степени при помощи сдавливания, а не нарезания. При вращении нижнего жернова зёрна отправляются по винтовым вырезам на ряд зубцов. Они, в свою очередь, перемалывают зерна до необходимого размера",
  },
  {
    "term": "Кофемолка",
    "description": "Приспособление для измельчения кофейных зерен",
  },
  {
    "term": "Крэк",
    "description": "Один из этапов в обжарке кофе. В процессе когда зерно становится практически коричневым в нем накапливаются водяные пары и углекислый газ, которые создают определённое давление внутри зерна. Как только оно становится слишком большим, зернышки трескаются, издавая характерный звук, и увеличиваются в размере практически вдвое",
  },
  {
    "term": "Q-грейдер",
    "description": "Сертифицированный специалист, который определяет, сколько баллов присвоить тому или иному образцу. Чтобы посчитать баллы, он проводит каппинг — определяет вкус, аромат, послевкусие, дефекты и общее впечатление от кофе",
  },
  {
    "term": "МИКРОЛОТ",
    "description": "Это неординарный кофе с высокими оценками на каппинге. Сложность выведения и добросовестная обработка на каждом этапе не позволяет продавать его в промышленных масштабах.\r\nИз одного микролота получают примерно 50 мешков в год, которые часто выкупаются одной партией и становятся эксклюзивным предложением. Конечно, чем реже лот, тем он дороже, к тому же, цена повышается за счет тщательности ухода, поэтому стоимость килограмма может достигать 1000$.",
  },
  {
    "term": "Минерализация воды",
    "description": "Наличие и количество минералов. Минеральность в необходимых количествах важна для лучшего вкуса и баланса напитка",
  },
  {
    "term": "МОНОСОРТ",
    "description": "Произошедший от английского single origin или mono-origin, этот термин по сути означает одно место происхождения, но т.к. такое размытое понятие может заключать в себе разные сорта из одной страны и сырьё нескольких производителей, сегодня упор именно на то, что такая маркировка свидетельствует о том, что это один урожай одной фермы.",
  },
  {
    "term": "Мытая обработка",
    "description": "Обработка, при которой мякоть кофейной ягоды депульпируют, оставляя пектиновый слой, после кофейные зерна подвергают ферментации (помещают в воду для естественного брожения или проводят без воды) и удаляют оставшуюся клейковину с зерна, после чего сушат",
  },
  {
    "term": "Натуральная обработка",
    "description": "Обработка, в процессе которой кофейные ягоды сушатся целиком на патио или африканских кроватях",
  },
  {
    "term": "Окисление",
    "description": "Процесс старения, начинается при контакте кофе с кислородом, в следствие чего кофе теряет летучие компоненты, которые отвечают за насыщенность аромата и вкуса кофе",
  },
  {
    "term": "ОБЖАРКА",
    "description": "Это процесс превращения зерен в привычные нам коричневатые. Он осуществляется в ростере – большом вращающемся металлическом барабане под воздействием тепла. Профессиональный обжарщик подбирает параметры так, чтобы раскрыть лучшие вкусовые качества и скрыть возможные дефекты.",
  },
  {
    "term": "Омни",
    "description": "Омни (англ. omni) – степень обжарки, которая подходит для всех способов приготовления",
  },
  {
    "term": "Осмос",
    "description": "Это метод водоподготовки, заключающийся в обессоливании воды. Сначала воду очищают от загрязнений, ржавчины и микробов. Затем она проходит через специальную мембрану, которая пропускает исключительно молекулы H2O. На выходе получается пермеат (очищенная и обессоленная вода)",
  },
  {
    "term": "Пак пресс",
    "description": "Пак пресс (англ. pack press) – автоматический темпер",
  },
  {
    "term": "ПИБЕРРИ",
    "description": "Чаще всего в ягоде созревает два зеркально расположенных зерна, но бывает, что вырастает только одно, напоминающее горошину (за что и получило свое название peaberry) и занимающее все внутреннее пространство плода. Такое явление составляет примерно 5% случаев. Считается, что у пиберри более яркие вкусо-ароматические характеристики.\r\nС чем же это связано? Точного ответа на этот вопрос пока не найдено.\r\n‍\r\nНо есть предположение, что когда его обжаривают, передача энергии происходит более качественно. Благодаря круглой форме она поступает в сердцевину равномерно. Для сравнения, при обычном раскладе зернышки обжариваются с плоской стороны быстрее.",
  },
  {
    "term": "Плотность зерна",
    "description": "Отношение массы кофе на единицу объема вещества",
  },
  {
    "term": "Плоские жернова",
    "description": "\"Режут\" зерна. Для этого они имеют три типа режущих поверхностей. Первая ступень дробит зёрна, попадающие в тракт кофемолки. Вторая измельчает крупные частицы кофе после дробления. Третья ступень «режет» частицы кофе до необходимой фракции, после чего кофе попадает либо в канал выхода, либо в специальную ёмкость",
  },
  {
    "term": "Помол кофе",
    "description": "Измельчение зерна до необходимой фракции",
  },
  {
    "term": "Профиль обжара",
    "description": "Технологическая карта обжарки, рецепт. Температурный график, на котором отображается все необходимые данные для правильной обжарки",
  },
  {
    "term": "Рефрактометр",
    "description": "Прибор для определения уровня TDS, который измеряет путём преломления света",
  },
  {
    "term": "Ростер",
    "description": "Оборудование для обжарки кофе",
  },
  {
    "term": "Семпл",
    "description": "Семпл (англ. sample) – образец",
  },
  {
    "term": "Семпл ростер",
    "description": "Семпл ростер (англ. sample roaster) – ростер для обжарки семплов, небольшого количества зерна (до 300 грамм)",
  },
  {
    "term": "Сенсорный анализ",
    "description": "Оценка кофе путём дегустации с описанием его основных характеристик – букет, послевкусие, кислотность, тело, однородность, чистота, баланс",
  },
  {
    "term": "Сита Kruve",
    "description": "Сита для просеивания молотого кофе с целью определения разброса фракции",
  },
  {
    "term": "Скрин",
    "description": "Обозначение размера кофейного зерна",
  },
  {
    "term": "Смесь/бленд",
    "description": "Смесь кофейных зёрен различных сортов. Смесь составляется из зёрен разного типа так, чтобы получился сбалансированный устойчивый вкус, который будет давать стабильный результат",
  },
  {
    "term": "Спешалти кофе",
    "description": "Спешалти кофе (англ. specialty coffee) – кофе сорта арабика, получивший свыше 80 баллов по шкале оценки Q-grade system.\r\n\r\nПоявление этого термина и всего движения – это заслуга одной сильной женщины и страстной кофеманки, и звали её Эрна Кнатсен. Она начала свою карьеру в кофейной сфере, когда устроилась секретарем в компанию, которая занималась продажей коммерческого кофейного напитка.\r\n‍\r\nС огромным энтузиазмом и знаниями в этом бизнесе в 80-х гг она основала собственную фирму Knutsen Coffees, Ltd.\r\n‍\r\nОна всегда неустанно ратовала за такие ценности, как внимательное отношение, идентичность и уникальность, что отражалось в продукте, который она предлагала клиентам.\r\n‍\r\nДелясь своими познаниями, вдохновляя людей, она фактически стала крестной матерью целой индустрии. Она давала определение спешалти только кофе с историей, который всегда правильно собран и обработан с учетом особенностей терруара.\r\n‍\r\nДля него подбираются зеленые зёрна с исключительными вкусо-ароматическими атрибутами, выращенные в уникальном географическом микроклимате. И еще один немаловажный фактор — они должны быть свежеобжаренными.",
  },
  {
    "term": "ТДС",
    "description": "ТДС (англ. TDS) – количество растворенных в воде твердых веществ. Другими словами: соотношение воды и растворенного в ней молотого кофе",
  },
  {
    "term": "Темперовка",
    "description": "Сжатие молотого кофе в холдере перед приготовлением для того, чтобы выдавить воздух, убрать воздушные карманы и как следствие получить равномерную экстракцию",
  },
  {
    "term": "Терруар",
    "description": "Это совокупность условий произрастания, который включает в себя:\r\n‍\r\n− высоту\r\n− температуру воздуха\r\n− количество осадков и солнечного света\r\n− интенсивность излучения\r\n− тип и глубину почв\r\n− флору и фауну",
  },
  {
    "term": "Триангуляция",
    "description": "Процесс определения одной лишней чашки с кофе из трех предложенных",
  },
  {
    "term": "Ферментация",
    "description": "Процесс, при котором дрожжи и бактерии расщепляют сахара на более простые вещества.\r\n\r\nЭто одна из стадий производства, в ходе которой удаляется клейковина, сахара превращаются в кислоты, газы и спирт. Процедура проходит в специальных ферментационных резервуарах – fermentation tanks и занимает в среднем от 12 до 24 часов в зависимости от климата и плотности клейкого вещества. Выделяется три вида:\r\n‍\r\n1) влажная\r\n2) сухая (распространена в регионах с дефицитом водных ресурсов)\r\n‍\r\nКак и при любом брожении, бактерии поедают сладкий липкий слой, способствуя его разрушению, остатки затем смывают. Первый метод требует от производителей предельной точности и внимательности, чтобы не переферментировать или недоферментировать.\r\n‍\r\n3) механическое удаление – задействует различные устройства, которые добиваются нужного эффекта с помощью трения. Это наименее затратный по времени и финансам способ, в котором нет риска переферментации.\r\n‍\r\nВ результате тщательно проведенных и контролируемых действии можно подчеркнуть интересные нотки, а неудачи могут привести к плачевным результатам: порче, непостоянству поставок и т.д.",
  },
  {
    "term": "Халлинг",
    "description": "Халлинг (англ. hulling) – процесс шелушения, при котором удаляют пергаментную оболочку с зерна",
  },
  {
    "term": "Хани",
    "description": "Хани (англ. honey) – обработка, при которой сочетаются элементы мытой и натуральной обработок. Мякоть с зерна частично удаляется, как при мытой обработке, но затем зёрна высушивают вместе с остатками мякоти, как при натуральной",
  },
  {
    "term": "Экстракция",
    "description": "Процесс извлечения вещества из раствора или сухой смеси с помощью растворителя. Применяя к кофе — переход вкуса и аромата из кофе в воду",
  },
  {
    "term": "CQI",
    "description": "CQI (Coffee Quality Institute) – институт качества кофе",
  }
]

export const countries = [
  { name: 'Мексика', slug: 'mexico', left: 18, top: 49 },
  { name: 'Сальвадор', slug: 'salvador', left: 19, top: 53 },
  { name: 'Гондурас', slug: 'honduras', left: 23, top: 55 },
  { name: 'Гватемала', slug: 'guatemala', left: 23, top: 57 },
  { name: 'Коста-Рика', slug: 'costa-rica', left: 24, top: 59 },
  { name: 'Колумбия', slug: 'colombia', left: 26, top: 61 },
  { name: 'Боливия', slug: 'bolivia', left: 24.5, top: 65 },
  { name: 'Перу', slug: 'peru', left: 26, top: 71 },
  { name: 'Бразилия', slug: 'brazil', left: 34, top: 70.2 },
  { name: 'Эфиопия', slug: 'ethiopia', left: 56.7, top: 56 },
  { name: 'Руанда', slug: 'rwanda', left: 54, top: 58 },
  { name: 'Уганда', slug: 'uganda', left: 55.7, top: 60.5 },
  { name: 'Бурунди', slug: 'burundi', left: 50, top: 63 },
  { name: 'Кения', slug: 'kenya', left: 56.7, top: 64 },
  { name: 'Индонезия', slug: 'indonesia', left: 78.3, top: 66.8 },
]

export const dadataPopularCities = [
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Москва",
    city: "Москва",
    fias_id: "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
    kladr_id: "7700000000000",
    postal_code: "101000",
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Санкт-Петербург",
    city: "Санкт-Петербург",
    fias_id: "c2deb16a-0330-4f05-821f-1d09c93331e6",
    kladr_id: "7800000000000",
    postal_code: "190000",
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Новосибирская",
    city: "Новосибирск",
    fias_id: "8dea00e3-9aab-4d8e-887c-ef2aaa546456",
    kladr_id: "5400000100000",
    postal_code: "630000",
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Свердловская",
    city: "Екатеринбург",
    fias_id: "2763c110-cb8b-416a-9dac-ad28a55b4402",
    kladr_id: "6600000100000",
    postal_code: "620000",
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Татарстан",
    city: "Казань",
    fias_id: "93b3df57-4c89-44df-ac42-96f05e9cd3b9",
    kladr_id: "1600000100000",
    postal_code: "420000",
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Нижегородская",
    city: "Нижний Новгород",
    fias_id: "555e7d61-d9a7-4ba6-9770-6caa8198c483",
    kladr_id: "5200000100000",
    postal_code: "603000",
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Челябинская",
    city: "Челябинск",
    fias_id: "a376e68d-724a-4472-be7c-891bdb09ae32",
    kladr_id: "7400000100000",
    postal_code: "454000"
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Самарская",
    city: "Самара",
    fias_id: "bb035cc3-1dc2-4627-9d25-a1bf2d4b936b",
    kladr_id: "6300000100000",
    postal_code: "443000"
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Башкортостан",
    city: "Уфа",
    fias_id: "7339e834-2cb4-4734-a4c7-1fca2c66e562",
    kladr_id: "0200000100000",
    postal_code: "450000"
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Ростовская",
    city: "Ростов-на-Дону",
    fias_id: "c1cfe4b9-f7c2-423c-abfa-6ed1c05a15c5",
    kladr_id: "6100000100000",
    postal_code: "344000"
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Омская",
    city: "Омск",
    fias_id: "140e31da-27bf-4519-9ea0-6185d681d44e",
    kladr_id: "5500000100000",
    postal_code: "644000"
  },
  {
    country: "Россия",
    country_iso_code: "RU",
    region: "Волгоградская",
    city: "Волгоград",
    fias_id: "a52b7389-0cfe-46fb-ae15-298652a64cf8",
    kladr_id: "3400000100000",
    postal_code: "400066"
  },
]

export const tasteTabs = [
  { id: 1, name: "Обжарка" },
  { id: 2, name: "Обработка" },
  { id: 3, name: "Терруар" },
]

export const tasteGroups = [
  { id: 1, tabId: 1, name: "Сладкие ароматы" },
  { id: 2, tabId: 1, name: "Сухофрукты" },
  { id: 3, tabId: 1, name: "Орехи и семечки" },
  { id: 4, tabId: 1, name: "Шоколад" },
  { id: 5, tabId: 1, name: "Специи" },
  { id: 6, tabId: 2, name: "Тропические фрукты" },
  { id: 7, tabId: 2, name: "Алкоголь" },
  { id: 8, tabId: 2, name: "Ароматные травы" },
  { id: 9, tabId: 3, name: "Фрукты" },
  { id: 10, tabId: 3, name: "Ягоды" },
  { id: 11, tabId: 3, name: "Цветочные" },
  { id: 12, tabId: 3, name: "Растительная ароматика" },
]

export const tastes = [
  { id: 1, groupId: 1, name: "Тростниковый сахар", color: "#9F744D" },
  { id: 2, groupId: 1, name: "Карамель", color: "#c37c54" },
  { id: 3, groupId: 1, name: "Мед", color: "#BC9337" },
  { id: 4, groupId: 1, name: "Кленовый сироп", color: "#C37F51" },
  { id: 5, groupId: 1, name: "Ваниль", color: "#F4E7C6" },
  { id: 6, groupId: 1, name: "Выпечка", color: "#c0a682" },
  { id: 7, groupId: 1, name: "Нуга", color: "#B69885" },
  { id: 8, groupId: 2, name: "Изюм", color: "#583432" },
  { id: 9, groupId: 2, name: "Чернослив", color: "#522145" },
  { id: 10, groupId: 2, name: "Финики", color: "#954E28" },
  { id: 11, groupId: 2, name: "Инжир", color: "#532D3B" },
  { id: 12, groupId: 3, name: "Миндаль", color: "#AB784E" },
  { id: 13, groupId: 3, name: "Фундук или лесной орех", color: "#cfb095" },
  { id: 14, groupId: 3, name: "Грецкий орех", color: "#B28965" },
  { id: 15, groupId: 3, name: "Кешью", color: "#A67247" },
  { id: 16, groupId: 3, name: "Арахис", color: "#b59562" },
  { id: 17, groupId: 3, name: "Пекан", color: "#A57053" },
  { id: 18, groupId: 3, name: "Кунжут", color: "#baa38b" },
  { id: 19, groupId: 4, name: "Темный шоколад", color: "#443731" },
  { id: 20, groupId: 4, name: "Молочный шоколад", color: "#84563c" },
  { id: 21, groupId: 4, name: "Какао", color: "#704a49" },
  { id: 22, groupId: 4, name: "Шоколадная выпечка", color: "#A8600B" },
  { id: 23, groupId: 5, name: "Кардамон", color: "#958d34" },
  { id: 24, groupId: 5, name: "Гвоздика", color: "#866459" },
  { id: 25, groupId: 5, name: "Кориандр", color: "#8E826A" },
  { id: 26, groupId: 5, name: "Анис или бадьян", color: "#635242" },
  { id: 27, groupId: 5, name: "Корица", color: "#9B4722" },
  { id: 28, groupId: 5, name: "Мускатный орех", color: "#7E5C54" },
  { id: 29, groupId: 5, name: "Душистый перец", color: "#634832" },
  { id: 30, groupId: 5, name: "Паприка", color: "#CE4D42" },
  { id: 31, groupId: 6, name: "Ананас", color: "#F8CA0A" },
  { id: 32, groupId: 6, name: "Манго", color: "#FBBF53" },
  { id: 33, groupId: 6, name: "Папайя", color: "#ffa266" },
  { id: 34, groupId: 6, name: "Маракуйя", color: "#fdc04e" },
  { id: 35, groupId: 6, name: "Личи", color: "#ba0d32" },
  { id: 36, groupId: 6, name: "Гуава", color: "#b7434d" },
  { id: 37, groupId: 6, name: "Кокос", color: "#f0ede5" },
  { id: 38, groupId: 6, name: "Дыня", color: "#f6896a" },
  { id: 39, groupId: 6, name: "Банан", color: "#f0cd5b" },
  { id: 40, groupId: 6, name: "Клубника", color: "#ee2737" },
  { id: 41, groupId: 6, name: "Черника", color: "#2C3642" },
  { id: 42, groupId: 6, name: "Темный виноград", color: "#7D3F7C" },
  { id: 43, groupId: 6, name: "Светлый виноград", color: "#A0AB4D" },
  { id: 44, groupId: 6, name: "Киви", color: "#7BAE57" },
  { id: 45, groupId: 6, name: "Арбуз", color: "#E8476A" },
  { id: 46, groupId: 7, name: "Ром", color: "#583432" },
  { id: 47, groupId: 7, name: "Виски", color: "#A94007" },
  { id: 48, groupId: 7, name: "Коньяк", color: "#8b645a" },
  { id: 49, groupId: 7, name: "Бурбон", color: "#B67721" },
  { id: 50, groupId: 7, name: "Сидр", color: "#d8a175" },
  { id: 51, groupId: 7, name: "Красное вино", color: "#77333b" },
  { id: 52, groupId: 7, name: "Белое вино", color: "#EEEDC4" },
  { id: 53, groupId: 7, name: "Бейлис", color: "#E7CEB5" },
  { id: 54, groupId: 8, name: "Розмарин", color: "#405e5c" },
  { id: 55, groupId: 8, name: "Тимьян или чабрец", color: "#50574c" },
  { id: 56, groupId: 8, name: "Тмин", color: "#c4bda3" },
  { id: 57, groupId: 8, name: "Эстрагон", color: "#A4B279" },
  { id: 58, groupId: 8, name: "Укроп", color: "#5D7050" },
  { id: 59, groupId: 9, name: "Лимон", color: "#FAF049" },
  { id: 60, groupId: 9, name: "Лайм", color: "#4F9D08" },
  { id: 61, groupId: 9, name: "Грейпфрут", color: "#E86C69" },
  { id: 62, groupId: 9, name: "Апельсин", color: "#FB8904" },
  { id: 63, groupId: 9, name: "Мандарин", color: "#FB6204" },
  { id: 64, groupId: 9, name: "Абрикос", color: "#FCE37F" },
  { id: 65, groupId: 9, name: "Слива", color: "#5D6CB8" },
  { id: 66, groupId: 9, name: "Персик", color: "#F9B63E" },
  { id: 67, groupId: 9, name: "Вишня", color: "#D80B16" },
  { id: 68, groupId: 9, name: "Черешня", color: "#59060B" },
  { id: 69, groupId: 9, name: "Яблоко зеленое", color: "#8DB600" },
  { id: 70, groupId: 9, name: "Яблоко красное", color: "#C7372F" },
  { id: 71, groupId: 9, name: "Груша", color: "#edea9b" },
  { id: 72, groupId: 9, name: "Гранат", color: "#6c2831" },
  { id: 73, groupId: 10, name: "Красная смородина", color: "#E10405" },
  { id: 74, groupId: 10, name: "Черная смородина", color: "#454757" },
  { id: 75, groupId: 10, name: "Малина", color: "#D32E5E" },
  { id: 76, groupId: 10, name: "Ежевика", color: "#432F4E" },
  { id: 77, groupId: 10, name: "Шиповник", color: "#ce8498" },
  { id: 78, groupId: 10, name: "Клюква или брусника", color: "#B7484F" },
  { id: 79, groupId: 10, name: "Крыжовник", color: "#b9b964" },
  { id: 80, groupId: 11, name: "Жасмин", color: "#C9C4A9" },
  { id: 81, groupId: 11, name: "Роза", color: "#CC212B" },
  { id: 82, groupId: 11, name: "Ромашка", color: "#E4A306" },
  { id: 83, groupId: 11, name: "Лаванда", color: "#afa4ce" },
  { id: 84, groupId: 12, name: "Черный чай листовой", color: "#3A0404" },
  { id: 85, groupId: 12, name: "Эрл Грей", color: "#304179" },
  { id: 86, groupId: 12, name: "Зеленый чай с жасмином", color: "#B59806" },
  { id: 87, groupId: 12, name: "Каркаде", color: "#B20404" },
  { id: 88, groupId: 12, name: "Мята", color: "#DDEDE8" },
  { id: 89, groupId: 12, name: "Томат", color: "#eb3c27" },
  { id: 90, groupId: 12, name: "Лемонграсс", color: "#DBD590" },
  { id: 91, groupId: 12, name: "Полевые травы", color: "#848B13" },
  { id: 92, groupId: 12, name: "Табачный лист", color: "#B6836E" },
  { id: 93, groupId: 12, name: "Кедр или сосна", color: "#AE7A56" },
  { id: 94, groupId: 12, name: "Имбирь", color: "#c1a68b" },
  { id: 95, groupId: 12, name: "Эвкалипт", color: "#b0c9b5" },
]

export const dalliZones = [
  {
    cities: [
      'Москва',
    ],
    options: [
      '09:00 - 13:00',
      '10:00 - 17:00',
      '11:00 - 15:00',
      '14:00 - 18:00',
      '18:00 - 22:00',
      '10:00 - 22:00',
    ],
    // options: [
    //   '09:00 - 16:00',
    //   '10:00 - 17:00',
    //   '17:00 - 22:00',
    //   '10:00 - 22:00',
    // ],
  },
  {
    cities: [
      'Санкт-Петербург',
    ],
    options: [
      '09:00 - 13:00',
      '10:00 - 17:00',
      '11:00 - 15:00',
      '14:00 - 18:00',
      '18:00 - 22:00',
      '10:00 - 22:00',
    ],
    // options: [
    //   '09:00 - 16:00',
    //   '10:00 - 17:00',
    //   '17:00 - 22:00',
    //   '10:00 - 22:00',
    // ],
  },
  {
    regions: [
      'Московская',
    ],
    options: [
      '10:00 - 16:00',
      '10:00 - 22:00',
      '12:00 - 22:00',
    ],
    // options: [
    //   '09:00 - 16:00',
    //   '15:00 - 22:00',
    //   '10:00 - 22:00',
    // ],
  },
  {
    regions: [
      'Ленинградская',
    ],
    options: [
      '09:00 - 22:00',
    ],
  },
  {
    cities: [
      'Белгород', 'Владимир', 'Воронеж', 'Калуга', 'Липецк', 'Орел', 'Рязань', 'Смоленск', 'Тверь', 'Тула', 'Тверь', 'Ярославль', 'Казань, Нижний Новгород', 'Самара', 'Саратов', 'Тольятти', 'Уфа', 'Чебоксары', 'Вологда', 'Великий Новгород', 'Ставрополь', 'Волгоград', 'Краснодар', 'Ростов-на-Дону', 'Екатеринбург', 'Пермь', 'Тюмень', 'Челябинск', 'Новосибирск', 'Омск',
    ],
    options: [
      '09:00 - 14:00',
      '09:00 - 18:00',
      '14:00 - 18:00',
    ],
  },
  {
    cities: [
      'Тамбов', 'Курск', 'Брянск', 'Иваново', 'Кострома',
    ],
    options: [
      '09:00 - 18:00',
    ],
  },
  {
    default: true,
    options: [
      '09:00 - 18:00',
    ],
  },
]